import React from 'react';

const Input = ({ children, id, label, layout = 'full' }) => {
    return (
        <label htmlFor={id} className={`clx-step__input ${layout}`}>
            <span className='clx-step__form-label'>
                {label}
            </span>
            {children}
        </label>
    );
};

export default Input;
